export class UURLs {
  public static isSecure(url: string): boolean {
    return url.startsWith("https://");
  }

  public static isLinkedIn(url: string): boolean {
    return url.startsWith("https://linkedin.com/") || url.startsWith("https://www.linkedin.com/");
  }

  public static isLinkedInCdn(url: string): boolean {
    return url.startsWith("https://media.licdn.com/");
  }

  public static getServerUrl(lang: string = ""): string {
    let url: string = "";

    if (typeof window !== "undefined") {
      url = window.location.origin;
    }

    if (process.env.VERCEL_URL) {
      url = `https://${process.env.VERCEL_URL}`;
    }

    if (process.env.NEXT_PUBLIC_APP_URL) {
      url = process.env.NEXT_PUBLIC_APP_URL;
    }

    if (!url) {
      url = "http://localhost:3000";
    }

    if (lang && !url.endsWith("/")) {
      url += "/";
    }

    if (lang) {
      url += lang;
    }

    return url;
  }
}
